import {
  createAuth0,
  Auth0Plugin,
  AUTH0_INJECTION_KEY,
} from "@auth0/auth0-vue";
import { ref, App } from "vue";
import type { AuthUser } from "@/types";

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || "";
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || "";
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || "";

export const isDevAuth =
  import.meta.env.DEV && (!AUTH0_DOMAIN || !AUTH0_CLIENT_ID);

export const DEV_USER: AuthUser = {
  sub: "auth0|dev-user",
  name: "Dev User",
  nickname: "dev",
  email: "dev@localhost",
  picture: undefined,
};

function createDevAuth0(): Auth0Plugin {
  const isLoading = ref(false);
  const isAuthenticated = ref(true);
  const user = ref(DEV_USER);
  const error = ref(null);
  const idTokenClaims = ref(null);

  const client = {
    isLoading,
    isAuthenticated,
    user,
    error,
    idTokenClaims,
    loginWithRedirect: async () => {
      console.log(
        "[Dev Auth] loginWithRedirect called - already authenticated",
      );
    },
    loginWithPopup: async () => {
      console.log("[Dev Auth] loginWithPopup called - already authenticated");
    },
    logout: async (options?: { logoutParams?: { returnTo?: string } }) => {
      console.log("[Dev Auth] logout called");
      isAuthenticated.value = false;
      user.value = undefined as any;
      if (options?.logoutParams?.returnTo) {
        window.location.href = options.logoutParams.returnTo;
      }
    },
    getAccessTokenSilently: async () => "dev-token",
    getAccessTokenWithPopup: async () => "dev-token",
    checkSession: async () => {},
    handleRedirectCallback: async () => ({ appState: {} }),
    getDpopNonce: () => undefined,
    setDpopNonce: () => {},
    generateDpopProof: async () => "",
    createFetcher: () => fetch,
  };

  return {
    install(app: App) {
      app.config.globalProperties.$auth0 = client as any;
      app.provide(AUTH0_INJECTION_KEY, client as any);
    },
  } as unknown as Auth0Plugin;
}

function createRealAuth0(): Auth0Plugin {
  return createAuth0({
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      scope: "openid profile email offline_access",
      audience: AUTH0_AUDIENCE,
    },
    useRefreshTokens: true,
    cacheLocation: "localstorage" as const,
  });
}

export const auth0 = isDevAuth ? createDevAuth0() : createRealAuth0();

if (isDevAuth) {
  console.log("[Dev Auth] Running with mock authentication (no Auth0 config)");
}
